import { FormattedMessage } from 'react-intl';

import { GameCoverageStatus } from '__generated__/globalTypes';
import { Tooltip } from 'atoms/tooltip/Tooltip';
import { BodyS } from 'atoms/typography';
import { playerGameStatusLabels } from 'lib/glossary';

import {
  LowCoverageLabel,
  NotCoveredLabel,
  UncertainCoverageLabel,
} from '../PlayingLabel';

export const GameCoverageBadge = ({
  coverageStatus,
}: {
  coverageStatus: GameCoverageStatus;
}) => {
  if (coverageStatus === GameCoverageStatus.FULL) return null;
  if (coverageStatus === GameCoverageStatus.UNCERTAIN)
    return (
      <Tooltip
        placement="bottom"
        title={
          <FormattedMessage
            {...playerGameStatusLabels.uncertain_coverage_detail}
          />
        }
      >
        <BodyS as="div" color="var(--c-nd-600)" bold>
          <UncertainCoverageLabel />
        </BodyS>
      </Tooltip>
    );
  if (coverageStatus === GameCoverageStatus.LOW)
    return (
      <Tooltip
        placement="bottom"
        title={
          <FormattedMessage {...playerGameStatusLabels.low_coverage_detail} />
        }
      >
        <BodyS as="div" color="var(--c-nd-600)" bold>
          <LowCoverageLabel />
        </BodyS>
      </Tooltip>
    );
  return (
    <BodyS as="div" color="var(--c-nd-600)" bold>
      <NotCoveredLabel />
    </BodyS>
  );
};
